module.exports = __webpack_public_path__ + "img/Main-Screen-Background.10c71d62.png";